<template>
  <activity-item-wrapper :type="CommunicationType.email" :actions :item>
    <template #content>
      <div class="flex items-center justify-between">
        <span
          v-tooltipable
          class="text-headline-new font-medium max-w-90 truncate"
        >
          {{ item.subject }}
        </span>
        <total-indicator
          v-if="hasMultipleEmails"
          :value="item.thread_messages_count"
        />
      </div>
      <activity-content
        :content="item.content_text ?? ''"
        :is-thread="hasMultipleEmails"
        @thread:open="emit('thread:open')"
      />
      <email-footer v-if="item" :item="item" />
      <send-deal-communication-modal
        v-if="showReplyModal"
        :deal-id="activeDeal.id"
        :type="CommunicationType.email"
        :deal-name="activeDeal.business?.business_legal_name"
        :reply-to-message="item.content_text ?? ''"
        @close-dialog="showReplyModal = false"
      />
    </template>
  </activity-item-wrapper>
</template>
<script setup lang="ts">
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";

import { CommunicationType } from "@/enums/communicationLogs";
import { useDealsBase } from "@/hooks/deals";

import SendDealCommunicationModal from "@/components/communication/SendDealCommunicationModal.vue";
import TotalIndicator from "@/components/deals/dataServices/cfa/moneythumb/TotalIndicator.vue";
import ActivityContent from "@/components/deals/dealActivity/ActivityContent.vue";
import ActivityItemWrapper from "@/components/deals/dealActivity/ActivityItemWrapper.vue";
import EmailFooter from "@/components/deals/dealActivity/emails/EmailFooter.vue";
import IconReply from "@/components/icons/IconReply.vue";

import type { EmailLogData } from "@/models/communicationLogs";

const { item } = defineProps<{
  item: EmailLogData;
}>();

const emit = defineEmits<{
  "thread:open": [];
}>();

const { t } = useI18n();
const { activeDeal } = useDealsBase();

const showReplyModal = ref(false);

const actions = computed(() => {
  if (item.is_outgoing) {
    return [];
  }

  return [
    {
      name: "reply",
      icon: IconReply,
      tooltip: t("COMMON.REPLY"),
      class: "hover:bg-gray-50",
      click: () => {
        showReplyModal.value = true;
      },
    },
  ];
});

const hasMultipleEmails = computed(() => item.thread_messages_count > 1);
</script>
